import { Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './Auth/login/login.component';
import { StrategyComponent } from './components/strategy/strategy.component';
import { CreateStrategyComponent } from './components/strategy/create-strategy/create-strategy.component';
import { StrategicPillarComponent } from './components/strategic-pillar/strategic-pillar.component';
import { StrategicValueComponent } from './components/strategic-value/strategic-value.component';
import { StrategicGoalComponent } from './components/strategic-goal/strategic-goal.component';
import { StrategicIndicatorComponent } from './components/strategic-indicator/strategic-indicator.component';
import { StrategicProjectComponent } from './components/strategic-project/strategic-project.component';
import { DefualtStrategyComponent } from './components/defualt-strategy/defualt-strategy.component';
import { CreateIndicatorComponent } from './components/strategic-indicator/create-indicator/create-indicator.component';
import { CreateProjectComponent } from './components/strategic-project/create-project/create-project.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { hasRoleGuard } from './guards/has-role.guard';
import { PerformanceComponent } from './components/performance/performance.component';
import { ProfileComponent } from './components/profile/profile.component';
import { LandingGuardGuard } from './guards/landing-guard.guard';
import { ReportsComponent } from './components/reports/reports.component';
import { IndicatorsChartsComponent } from './components/indicators-charts/indicators-charts.component';
import { AdminHomeComponent } from './admin/admin-home/admin-home.component';
import { DepartmentComponent } from './admin/department/department.component';
import { PermissionsComponent } from './admin/permissions/permissions.component';
import { AdminReportComponent } from './admin/admin-report/admin-report.component';
import { ProjectEditPermissionsComponent } from './admin/project-edit-permissions/project-edit-permissions.component';
import { OrgChartComponent } from './components/org-chart/org-chart.component';
import { isAuthnticatedGuard } from './guards/is-authnticated.guard';
import { AllNotificationsComponent } from './components/all-notifications/all-notifications.component';
import { StrategyAlignmentComponent } from './ststrategy-alignment/strategy-alignment.component';
import { OrganizationHierarchyComponent } from './components/organization-hierarchy/organization-hierarchy.component';
import { NavigateProofsComponent } from './components/navigate-proofs/navigate-proofs.component';
import { KanbanComponent } from './components/kanban/kanban.component';
import { FileAuditorComponent } from './components/projects-hub-file-auditor/projects-hub-file-auditor.component';
import { IndicatorsFileAudtiorComponent } from './components/indicators-file-audtior/indicators-file-audtior.component';
import { StrategyAdminHomeComponent } from './components/home/strategy-admin-home/strategy-admin-home.component';
import { StrategyExecutorHomeComponent } from './components/home/strategy-executor-home/strategy-executor-home.component';
import { StrategyManagerHomeComponent } from './components/strategy-manager-home/strategy-manager-home.component';
import { StrategyExecComponent } from '../strategy-exec/strategy-exec.component';
import { ExecuterTestComponent } from './components/executer-test/executer-test.component';
import { TasksComponent } from './components/tasks/tasks.component';
import { ProjectFileAuditSingleComponent } from './project-file-audit-single-container/project-file-audit-single.component';
import { IndicatorFileAuditSingleComponent } from './components/indicator-file-audit-single/indicator-file-audit-single.component';
import { GoalsIndicatorsComponent } from './components/goals-indicators/goals-indicators.component';
import { listStrategiesResolver } from './_resolvers/list-strategies-.resolver';
import { strategicIndicatorResolver } from './_resolvers/strategic-indicator.resolver';
import { listProjectResolver } from './_resolvers/list-project.resolver';
import { strategicGoalsResolver } from './_resolvers/strategic-goals-.resolver';
import { strategyManagerHomeResolver } from './_resolvers/strategy-manager-home.resolver';
import { strategyExecResolver } from './_resolvers/strategy-exec.resolver';
import { strategicPillarResolver } from './_resolvers/strategic-pillar.resolver';
import { strategicValueResolver } from './_resolvers/strategic-value.resolver';
import { GoalsProjectsComponent } from './components/goals-projects/goals-projects.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { STRATEGY_EXEC_ROLES } from './interfaces';
import { tasksResolver } from './_resolvers/tasks.resolver';
import { Forbidden403Component } from './shared/components/forbidden403/forbidden403.component';
import { hasAccessGuard } from './guards/has-access.guard';
import { goalsProjectsResolver } from './_resolvers/goals-projects.resolver';
import { goalsIndicatorsResolver } from './_resolvers/goals-indicators.resolver';
import { RouteTitelResolver } from './_resolvers/route-titel.Resolver';
import { EmployeeReportsComponent } from './components/employee-reports/employee-reports.component';
import { DepartmentApprovalsComponent } from './components/department-approvals/department-approvals.component';
import { KnowledgeLibraryComponent } from './components/knowledge-library/knowledge-library.component';




export const routes: Routes = [

    { path: '', component: LandingPageComponent, pathMatch: 'full' },
    { path: 'login', component: LoginComponent, canActivate: [LandingGuardGuard] },

    {
        path: 'strategy-alignment/:strategyId',
        component: StrategyAlignmentComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { isSidebar: false, pageName: "StrategyAlignment" }
    },
    {
        path: 'organization-hierarchy',
        component: OrganizationHierarchyComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { isSidebar: false, pageName: "OrganizationHierarchy" }
    }
    ,
    {
        path: 'file-manager', component: NavigateProofsComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { pageName: "FileExplorer" }
    },
    { path: 'kanban', component: KanbanComponent, canActivate: [isAuthnticatedGuard] },
    {
        path: 'project-file-auditor',
        component: ProjectFileAuditSingleComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { pageName: "ReviewMilestoneOutputs" }
    },
    {
        path: 'indicator-FileAuditsingle',
        component: IndicatorFileAuditSingleComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { pageName: "ReviewIndicatorsOutcomesProofs" }
    },
    {
        path: 'file-auditor',
        component: FileAuditorComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { pageName: "ReviewMilestoneOutputs" }
    },
    {
        path: 'indicators-file-auditor',
        component: IndicatorsFileAudtiorComponent,
        title: RouteTitelResolver as any,
        canActivate: [isAuthnticatedGuard],
        data: { pageName: "ReviewIndicatorsOutcomesProofs" }

    },
    { path: 'strategy-exec-home', component: StrategyExecutorHomeComponent, canActivate: [isAuthnticatedGuard] },
    { path: 'strategy-admin-home', component: StrategyAdminHomeComponent, canActivate: [isAuthnticatedGuard] },
    { path: 'executer-test', component: ExecuterTestComponent, canActivate: [isAuthnticatedGuard] },
    {
        path: 'tasks',
        component: TasksComponent,
        resolve: { viewBag: tasksResolver },
        title: RouteTitelResolver as any,
        data: { pageName: "Tasks" }
    },
    { path: 'onboarding', component: OnboardingComponent, canActivate: [isAuthnticatedGuard] },
    {
        path: '', children: [

            {
                path: '',
                children: [
                    {
                        path: 'strategy', component: StrategyComponent,
                        resolve: { strategies: listStrategiesResolver },
                        data: { pageName: 'Strategies' },
                        title: RouteTitelResolver as any
                    },
                    {
                        path: 'createStrategy/:id', component: CreateStrategyComponent,
                        data: { pageName: 'Strategy' },
                        title: RouteTitelResolver as any
                    },
                    {
                        path: 'strategicPillar/:strategyId', component: StrategicPillarComponent,
                        resolve: { viewBag: strategicPillarResolver },
                        title: RouteTitelResolver as any,
                        data: { pageName: 'StrategySPillars' },
                    },
                    {
                        path: 'StrategicValue/:strategyId',
                        component: StrategicValueComponent,
                        resolve: { viewBag: strategicValueResolver },
                        title: RouteTitelResolver as any,
                        data: { pageName: 'StrategySValues' },
                    },
                ],
                data: { roles: ['strategy_admin'], animation: 'createStrategy' },
                canActivate: [hasRoleGuard]
            },
            {
                path: 'strategy-executor-home',
                component: StrategyExecComponent,
                resolve: { viewBag: strategyExecResolver },
                data: { roles: [...STRATEGY_EXEC_ROLES], pageName: 'Home' },
                title: RouteTitelResolver as any
            },
            {
                path: 'strategy-manager-home', component: StrategyManagerHomeComponent,
                resolve: { viewBag: strategyManagerHomeResolver },
                data: { roles: ['strategy_admin'], pageName: 'Home' },
                title: RouteTitelResolver as any
            },

            //deprecated
            { path: 'DefualtStrategy', component: DefualtStrategyComponent },
            {
                path: 'strategies/:strategyId/indicators/:indicatorId',
                component: CreateIndicatorComponent,
                title: RouteTitelResolver as any,
                data: { pageName: 'Indicator' },
                canActivate: [hasAccessGuard]
            },
            {
                path: 'strategies/:strategyId/projects/:projectId',
                component: CreateProjectComponent,
                canActivate: [hasAccessGuard]
            },

            //========= for all users =============
            {
                path: 'profile',
                component: ProfileComponent,
                title: RouteTitelResolver as any,
                data: { pageName: "Profile" }
            },

            { path: 'goals-indicators', component: GoalsIndicatorsComponent, resolve: { viewBag: goalsIndicatorsResolver } },
            { path: 'goals-projects', component: GoalsProjectsComponent, resolve: { viewBag: goalsProjectsResolver } },
            { path: 'org-chart', component: OrgChartComponent },
            { path: 'all-notifications', component: AllNotificationsComponent },
            { path: 'forbidden', component: Forbidden403Component },
            {
                path: 'strategic-knowledge-library',
                component: KnowledgeLibraryComponent,
                title: RouteTitelResolver as any,
                data: { pageName: "StrategicKnowledgeLibrary" }
            },
            {
                path: 'my-reports',
                component: EmployeeReportsComponent,
                title: RouteTitelResolver as any,
                data: { pageName: "MyReports" }
            },
            {
                path: 'department-approvals',
                component: DepartmentApprovalsComponent,
                title: RouteTitelResolver as any,
                data: { 
                    pageName: "DepartmentApprovals",
                    roles: ['department_admin', 'section_admin']
                },
                canActivate: [hasRoleGuard]
            },
            {
                path: 'strategies/goals',
                component: StrategicGoalComponent,
                resolve: { goalPageData: strategicGoalsResolver },
                title: RouteTitelResolver as any,
                data: { pageName: 'StrategicGoals' }
            },
            {
                path: 'strategies/indicators',
                component: StrategicIndicatorComponent,
                resolve: { indicatorPageData: strategicIndicatorResolver },
                title: RouteTitelResolver as any,
                data: { pageName: 'StrategicIndicators' }
            },
            {
                path: 'strategies/projects',
                component: StrategicProjectComponent,
                resolve: { projectPageData: listProjectResolver },
                title: RouteTitelResolver as any,
                data: { pageName: 'Initiatives' }
            },
            //========= for all users end =============
            {
                path: '',
                children: [

                    {
                        path: 'reports',
                        component: ReportsComponent,
                        title: RouteTitelResolver as any,
                        data: {
                            pageName: "Reports"
                        }

                    },
                    {
                        path: 'performance',
                        component: PerformanceComponent,
                        title: RouteTitelResolver as any,
                        data: {
                            pageName: "Performance"
                        }
                    },
                    {
                        path: 'indicators-performance',
                        component: IndicatorsChartsComponent,
                        title: RouteTitelResolver as any,
                        data: {
                            pageName: "IndicatorSOutcomes"
                        }

                    },
                ],
                data: { roles: ['senior_admin', 'strategy_admin'], animation: 'openClosePage' }, canActivate: [hasRoleGuard]
            },

            { path: 'dashboard', component: DashboardComponent, title: RouteTitelResolver as any, data: { roles: ['senior_admin', 'strategy_admin'], pageName: 'OverallOperationalPerformance' }, canActivate: [hasRoleGuard] },
        ],
        canActivate: [isAuthnticatedGuard],
        data: { animation: 'openClosePage' }
    },
    {
        path: 'admin', children: [
            {
                path: 'admin-home',
                component: AdminHomeComponent,
                title: RouteTitelResolver as any,
                data: {
                    pageName: "ControlPanel"
                }
            },
            {
                path: 'department',
                component: DepartmentComponent,
                title: RouteTitelResolver as any,
                data: {
                    pageName: "Department"
                }
            },
            {
                path: 'permission',
                component: PermissionsComponent,
                title: RouteTitelResolver as any,
                data: {
                    pageName: "Permissions"
                }
            },
            {
                path: 'project-edit-permissions',
                component: ProjectEditPermissionsComponent,
                title: RouteTitelResolver as any,
                data: {
                    pageName: "ProjectEditPermissions"
                }
            },
            { path: 'reports', component: AdminReportComponent },
        ], canActivate: [hasRoleGuard], data: { roles: ['admin', 'senior_admin', 'strategy_admin'] }
    }
];
